export const formatIp = (ip) => {
  if (!ip) return "";
  return ip
    .replace(/[^\d.]/g, "")
    .replace(/\.{2,}/g, ".")
    .replace(/^\./, "")
    .replace(/(\d{3})(?=\d)/g, "$1.")
    .split(".")
    .slice(0, 4)
    .join(".");
};
